/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Not_Found_DescriptionInputs */

const sv_page_not_found_description = /** @type {(inputs: Page_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrollera adressen eller anv?nd navigationen f?r att g? vidare.`)
};

const en_page_not_found_description = /** @type {(inputs: Page_Not_Found_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The page could not be found. Check the address or use the navigation to continue.`)
};

/**
* | output |
* | --- |
* | "The page could not be found. Check the address or use the navigation to continue." |
*
* @param {Page_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_not_found_description = /** @type {((inputs?: Page_Not_Found_DescriptionInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Not_Found_DescriptionInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_not_found_description(inputs)
	return en_page_not_found_description(inputs)
});